import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { ComponentRemovalCategories } from './componentRemovalCategories.types';

export const componentRemovalCategoriesPullQueryBuilder = (
  document: ComponentRemovalCategories,
) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query mainComponentRemovalCategories($lastRequested: DateTime!) {
      mainComponentRemovalCategories(lastRequested: $lastRequested) {
        name
        sort
        isActive
        dateModified
        dateCreated
        pkComponentRemovalCategory
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified || doc?.dateCreated },
  };
};
